import { Component, computed, input } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, ButtonComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { InvoiceStatus } from '../../services/dto/invoice-status';

export const invoiceStatusLabel = (invoiceStatus: InvoiceStatus) =>
  `project.invoiceStatus.${InvoiceStatus[invoiceStatus]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-invoice-status',
  templateUrl: './invoice-status.component.html',
  styleUrl: './invoice-status.component.scss',
  imports: [BadgeComponent, ButtonComponent, FontIconComponent, TranslatePipe],
})
export class InvoiceStatusComponent extends CamBaseComponent {
  status = input.required<number | InvoiceStatus>();

  isButton = input(false);

  readOnly = input(false);

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  readonly label = computed(() => invoiceStatusLabel(this.status()));

  readonly type = computed(() => {
    switch (this.status()) {
      case InvoiceStatus.Validated:
        return 'success';
      case InvoiceStatus.Cancelled:
        return 'danger';
      case InvoiceStatus.Draft:
        return 'secondary';
      default:
        return 'primary';
    }
  });

  public getClass(): string {
    return `button-${this.type()}`;
  }

  readonly iconName = computed(() => {
    switch (this.status()) {
      case InvoiceStatus.Draft:
        return 'doc';
      case InvoiceStatus.Cancelled:
        return 'task-canceled';
      case InvoiceStatus.Validated:
        return 'tasks';
      default:
        return 'info';
    }
  });
}
